import axios from 'axios';

// 워크샵용 임시 API. 공용 axiosInstance는 로딩 오버레이를 띄우고 4xx/5xx에서
// /error로 리다이렉트하므로, 게임 진행을 막지 않도록 인터셉터 없는 별도
// 인스턴스를 사용한다. 호출 실패는 호출부에서 무시한다(기록만 유실).
const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1',
});

export const createIcebreakerDraw = async (
  participantName,
  questionNo,
  questionText,
) => {
  const response = await client.post('/icebreaker/draws', {
    participantName,
    questionNo,
    questionText,
  });
  return response.data.data;
};

export const markIcebreakerSkipped = (drawId) =>
  client.patch(`/icebreaker/draws/${drawId}/skip`);

export const markIcebreakerAnswered = (drawId) =>
  client.patch(`/icebreaker/draws/${drawId}/answer`);
